import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'checkout.cartPage.discoveryBoxModal.title',
    defaultMessage: 'Your Discovery Box',
    description: 'Title of discovery box modal',
  },
  removeProduct: {
    id: 'checkout.cartPage.discoveryBoxModal.sampleUnavailable',
    defaultMessage: 'Sample is unavailable',
    description: 'Unavailable sample',
  },
  buttonText: {
    id: 'checkout.cartPage.discoveryBoxModal.editSelection',
    defaultMessage: 'Edit selection',
    description: 'Button text for edit selection',
  },
});
